import "@babel/polyfill";
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import VueRouter from 'vue-router'
import * as VueGoogleMaps from "vue2-google-maps";
import SingleListing from './components/SingleListing.vue'
import EventsListing from './components/EventsListing.vue'
import EventsListingMuswell from './components/EventsListingMuswell.vue'
import jquery from 'jquery'


window.$ = jquery
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBi01CDDkbs961shpw5iiMw9VyaR5I-3VA",
    libraries: "places" // necessary for places input
  }
});


const routes = [
	{ path: '/', component: EventsListing, name: 'events' },
	{ path: '/muswellbrooks-upperhunter', component: EventsListingMuswell, name: 'events muswell hunter' },
	{ path: '/:url/:id', component: SingleListing, name: 'single' },
]

const router = new VueRouter({
	mode: 'history',
  routes // short for `routes: routes`
})

//scroll to top on route
router.beforeEach(function (to, from, next) {
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
    next();
});

// Now the app has started!
new Vue({
	router,
  	render: h => h(App)
}).$mount('#app')
